import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage/LoginPage';
import DashboardPage from './pages/DashboardPage/DashboardPage';
import Dashboardv2Page from './pages/Dashboardv2Page/Dashboardv2Page';
import Dashboardv3Page from './pages/Dashboardv3Page/Dashboardv3Page';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './context/AuthContext';
import './App.css';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="text-center mt-20 text-gray-500 font-bold">Restoring session...</div>;
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } />
        <Route path="/dashboard-v2" element={
          <ProtectedRoute>
            <Dashboardv2Page />
          </ProtectedRoute>
        } />
        <Route path="/dashboard-v3" element={
          <ProtectedRoute>
            <Dashboardv3Page />
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to={user ? "/dashboard-v3" : "/login"} />} />
      </Routes>
    </div>
  );
}

export default App;
